import axios from "axios";
import { getCaseRestorations } from "../lib/dental";
import { caseOfferedPrice } from "../lib/pricing";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Build NON-PHI case metadata for AI Match. Never includes patient name/id, notes,
// STL urls, photos or any private/clinical data — only public matching signals.
export function caseToMeta(c) {
  const restos = getCaseRestorations(c) || [];
  const restorationType = c.restorationType || restos[0]?.type || "";
  const material = c.material || restos[0]?.material || "";
  return {
    id: c.id,
    restorationType,
    material,
    toothNumbers: c.toothNumbers || "",
    deadline: c.deadline || "",
    offeredPrice: caseOfferedPrice(c) || null,
    complexity: c.ai?.complexity || "",
    tags: Array.isArray(c.ai?.tags) ? c.ai.tags.slice(0, 6) : [],
  };
}

// Build NON-PHI designer metadata from a user doc's designerProfile.
export function designerToMeta(dp = {}, extra = {}) {
  return {
    specialties: dp.specialties || "",
    experience: dp.experience || "",
    software: dp.software || "",
    turnaround: dp.turnaround || "",
    portfolio: (dp.portfolio || dp.description || "").slice(0, 300),
    ...extra,
  };
}

// Designer -> best cases. Returns a map { caseId: { score, level, reason } }.
export async function matchCasesForDesigner(designerMeta, cases, locale = "en") {
  const { data } = await axios.post(`${API}/ai-match/cases`, {
    designer: designerMeta,
    cases: cases.map(caseToMeta),
    locale,
  });
  if (data?.status !== "ok") throw new Error(data?.message || "AI Match failed");
  const map = {};
  (data.matches || []).forEach((m) => { map[m.id] = m; });
  return map;
}

// Lab -> compare applicants. `candidates` = [{ id, ...designerMeta, proposedPrice, completedCount }].
export async function matchDesignersForCase(caseMeta, candidates, locale = "en") {
  const { data } = await axios.post(`${API}/ai-match/designers`, {
    case: caseMeta,
    candidates,
    locale,
  });
  if (data?.status !== "ok") throw new Error(data?.message || "AI Match failed");
  return data.matches || [];
}
